import Api from "./api";
import { ajaxJWT } from "@/utils/request";

export function Dashboard_query(parameter) {
  return ajaxJWT({
    url: Api.dashboard,
    method: "post",
    data: parameter
  });
}
